import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { AuthService } from 'services/auth.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styles: []
})
export class ErrorComponent implements OnInit {

  constructor(
  	private location: Location,
    private router: Router,
    private authService: AuthService,
  ) { 

  }

  ngOnInit() {
  	
  }

  redirect() {
    let url = '/login';
    
    if (this.authService.role) {
      url = '/' + this.authService.role + '/dashboard';
    }

    this.router.navigateByUrl(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/component/shared/error_component/error.component.ts